import { networkManager } from '../network/NetworkManager';

export class HTMLHUD {
    private container: HTMLDivElement;
    private healthFill: HTMLDivElement;
    private healthText: HTMLDivElement;
    private capacityFill: HTMLDivElement;
    private capacityText: HTMLDivElement;
    private modeText: HTMLDivElement;

    constructor(isMultiplayer: boolean) {
        this.container = document.createElement('div');
        this.container.id = 'game-hud';
        // Positioned to the left of the minimap (120px width + 5px margin + 15px spacing = ~140px)
        this.container.style.cssText = `
            position: fixed;
            top: 5px;
            right: 140px;
            width: auto;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            pointer-events: none;
            z-index: 100;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 5px;
        `;

        // Mode Indicator (Top element in stack)
        this.modeText = document.createElement('div');
        this.modeText.style.cssText = `
            font-size: 14px;
            font-weight: bold;
            color: #ffffff;
            text-shadow: 1px 1px 2px black;
            text-align: right;
            margin-bottom: 5px;
        `;

        if (isMultiplayer) {
            this.modeText.innerHTML = `🌐 Connected: <span style="color: #4ecdc4">${networkManager.peerIds.length + 1} players</span>`;
        } else {
            this.modeText.innerHTML = `WASD/Arrows: Move <span style="margin: 0 5px">|</span> Space: Fart`;
        }
        this.container.appendChild(this.modeText);

        // Create Health Bar
        const healthRow = this.createBarRow('❤️', '#00b894', '100 HP');
        this.healthFill = healthRow.fill;
        this.healthText = healthRow.text;
        this.container.appendChild(healthRow.container);

        // Create Capacity Bar
        const capacityRow = this.createBarRow('💨', '#fdcb6e', '100%');
        this.capacityFill = capacityRow.fill;
        this.capacityText = capacityRow.text;
        this.container.appendChild(capacityRow.container);

        document.body.appendChild(this.container);
    }

    private createBarRow(icon: string, color: string, initialText: string) {
        const row = document.createElement('div');
        row.style.cssText = `
            display: flex;
            align-items: center;
            gap: 10px;
        `;

        const iconEl = document.createElement('div');
        iconEl.textContent = icon;
        iconEl.style.fontSize = '20px'; // Slightly larger for visibility
        row.appendChild(iconEl);

        const barContainer = document.createElement('div');
        barContainer.style.cssText = `
            width: 200px;
            height: 18px;
            background: rgba(0, 0, 0, 0.5);
            border-radius: 9px;
            overflow: hidden;
            position: relative;
            border: 1px solid rgba(255, 255, 255, 0.2);
        `;

        const fill = document.createElement('div');
        fill.style.cssText = `
            width: 100%;
            height: 100%;
            background-color: ${color};
            transition: width 0.2s ease-out, background-color 0.2s;
        `;
        barContainer.appendChild(fill);

        const text = document.createElement('div');
        text.textContent = initialText;
        text.style.cssText = `
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 11px;
            font-weight: bold;
            color: white;
            text-shadow: 1px 1px 1px rgba(0,0,0,0.8);
        `;
        barContainer.appendChild(text);

        row.appendChild(barContainer);

        return { container: row, fill, text };
    }

    public updateHealth(health: number, maxHealth: number): void {
        const pct = Math.max(0, Math.min(100, (health / maxHealth) * 100));
        this.healthFill.style.width = `${pct}%`;
        this.healthText.textContent = `${Math.ceil(health)} HP`;

        // Dynamic color
        if (pct > 50) {
            this.healthFill.style.backgroundColor = '#00b894'; // Green
        } else if (pct > 25) {
            this.healthFill.style.backgroundColor = '#fdcb6e'; // Orange
        } else {
            this.healthFill.style.backgroundColor = '#d63031'; // Red
        }
    }

    public updateCapacity(capacity: number): void {
        const pct = Math.max(0, Math.min(100, capacity));
        this.capacityFill.style.width = `${pct}%`;
        this.capacityText.textContent = `${Math.ceil(capacity)}%`;
    }

    public destroy(): void {
        this.container.remove();
    }
}
